// Static site data baked into the build. No backend required.
import data from './siteData.json';

export const artistInfo = data.artistInfo;
export const collections = data.collections;
export const exhibitions = data.exhibitions; // grouped by year, descending
export const shop = data.shop;
export const commissionProcess = data.commissionProcess;
export const instagramImages = data.instagramImages;

export const getCollection = (id) =>
  collections.find((c) => c.id === id) || null;

export default data;
